/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'fabric.linkPicker.button.cancel': 'İptal',
  'fabric.linkPicker.button.insert': 'Ekle',
  'fabric.linkPicker.button.save': 'Kaydet',
  'fabric.linkPicker.clearLink': 'Temizle',
  'fabric.linkPicker.clearLinkText': 'Metni temizle',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {sonuç bulunamadı} one {{count,number} sonuç bulundu} other {{count,number} sonuç bulundu}}',
  'fabric.linkPicker.linkAriaLabel': 'Alana bir bağlantı yazın ya da yapıştırın',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Bağlantı göster yardım metni',
  'fabric.linkPicker.linkHelperTextLabel': 'Bu bağlantıya bir başlık ya da açıklama verin',
  'fabric.linkPicker.linkInvalid': 'Geçerli bir URL girin.',
  'fabric.linkPicker.linkLabel': 'Bağlantı',
  'fabric.linkPicker.linkPlaceholder': 'Bağlantı yapıştırın',
  'fabric.linkPicker.linkTextAriaLabel': 'Bağlantı metni',
  'fabric.linkPicker.linkTextLabel': 'Görüntülenecek metin (isteğe bağlı)',
  'fabric.linkPicker.linkTextPlaceholder': 'Görüntülenecek metin',
  'fabric.linkPicker.listTitle.recentlyViewed': 'En Son Görüntülenenler',
  'fabric.linkPicker.listTitle.results': 'Sonuçlar',
  'fabric.linkPicker.search.error.description': 'Sayfayı yenileyin veya sorun devam ederse <a>Atlassian Destek</a> ekibiyle iletişime geçin.',
  'fabric.linkPicker.search.error.heading': 'Veri yüklenirken bir sorunla karşılaşıldı.',
  'fabric.linkPicker.search.error.retry': 'Yenile',
  'fabric.linkPicker.search.linkAriaLabel': 'Alana yazmaya başladığınızda öneriler aşağıda görünecek',
  'fabric.linkPicker.search.linkLabel': 'Bir bağlantı arayın ya da yapıştırın',
  'fabric.linkPicker.search.linkPlaceholder': 'Son kullanılan bağlantıları bulun veya yeni bir bağlantı yapıştırın',
  'fabric.linkPicker.search.noResults.description': 'Farklı bir terim aramayı deneyin.',
  'fabric.linkPicker.search.noResults.heading': 'Aramanızla eşleşen sonuç bulunamadı.',
  'fabric.linkPicker.status.submitting': 'Gönderiliyor',
  'fabric.linkPicker.time.message.updated': 'Son güncelleme: {time}',
  'fabric.linkPicker.time.message.viewed': 'Son görüntüleme: {time}',
  'fabric.linkPicker.unhandledError.description': 'Sayfayı yeniden yüklemeyi deneyin.',
  'fabric.linkPicker.unhandledError.heading': 'Bir hata oluştu!'
};